export enum LowesStormHandleEvents {
    PublishFormModelDidUpdate = 'LowesStormHandle.Publish.FormModelDidUpdate',
}